import G2Dialog from '../components/Utilities/G2Dialog.vue'
import G2Popover from '../components/Utilities/G2Popover.vue'

export default {
    install(Vue) {
        const dialog = new (Vue.extend(G2Dialog))()
        const popover = new (Vue.extend(G2Popover))()
        
        const dialog_vm = dialog.$mount()
        const popover_vm = popover.$mount()
        document.body.appendChild(dialog_vm.$el)
        document.body.appendChild(popover_vm.$el)
        
        Vue.prototype.$g2dialogComponent = dialog
        Vue.prototype.$g2popoverComponent = popover
        Vue.prototype.g2dialog = {
            $confirm: (message) => {
                return Vue.prototype.$g2dialogComponent.confirm(message)
            },
            $alert: (message) => {
                return Vue.prototype.$g2dialogComponent.alert(message)
            },
            $popover: (event, content) => {
                const top = event && event.clientY
                const left = event && event.clientX
                return Vue.prototype.$g2popoverComponent.show({ top, left }, content)
            }
        }
    }
}